import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { createStore } from 'redux'
import { BrowserRouter, Route } from 'react-router-dom'
import './index.css'
import App from './App'
import reducers from './reducers'
import { unregister } from './registerServiceWorker'
import 'grommet-css'
const store = process.env.NODE_ENV === 'development' ?
    createStore(reducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()) :
    createStore(reducers)

render(
  <Provider store={store}>
    <BrowserRouter>
      <Route path="/" component={App}/>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
)
unregister()



// WEBPACK FOOTER //
// ./src/index.js